import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }
const _hoisted_2 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_3 = { class: "table-responsive table-scroll-mobile" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "fw-medium text-black-emphasis" }
const _hoisted_6 = { class: "fw-medium text-black-emphasis" }
const _hoisted_7 = { class: "fw-medium text-black-emphasis" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_11 = { class: "modal-content p-15 p-md-40" }
const _hoisted_12 = { class: "modal-body" }
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SheetsApp',
  setup(__props) {

const sheets = ref<any[]>([]);
const showModal = ref(false);
const { showToast } = useAppToast();

const form = ref({
  sheet_name: "",
  sheet_key: "",
});

const loadSheets = async () => {
  const { data } = await api.get("/api/auth/client/sheets");
  sheets.value = data.data;
};

onMounted(loadSheets);
const loading = ref(false);

const submit = async () => {
  if (loading.value) return; // 🔒 prevent double submit

  loading.value = true;

  try {
    const res = await api.post("/api/auth/client/sheets", form.value);

    if (res.data?.success) {
      showToast("Sheet ajouté avec succès", "success");
      closeModal();
      await loadSheets();
    } else {
      showToast(
        res.data?.message ?? "Erreur lors de l'ajout du sheet",
        "error"
      );
    }
  } catch (error) {
    console.error("Submit error:", error);

    showToast(error.response?.data?.message ?? "Erreur serveur", "error");
  } finally {
    loading.value = false; // ✅ ALWAYS restore
  }
};

const removeSheet = async (id: number) => {
  Swal.fire({
    text: "Vous voulez supprimer ce sheet ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      await api.delete(`/api/auth/client/sheets/${id}`);
      loadSheets();
    }
  });
};

const importModel = async () => {
  try {
    const response = await api.get("/api/auth/client/ModelSheetExcel", {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "ModelSheetExcel.xlsx";

    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel model:", error);
    // Optional: show toast / alert
  }
};

const addSheetyModal = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;

onMounted(() => {
  if (addSheetyModal.value) {
    modalInstance = new Modal(addSheetyModal.value, {
      backdrop: "static",
      keyboard: false,
    });
  }
});

const openModal = () => {
  modalInstance?.show();
};

const closeModal = () => {
  modalInstance?.hide();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 mb-4" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: openModal
          }, " + Nouveau Sheet ")
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row mt-3" }, [
          _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("h3", { class: "text-center mb-3" }, "Exemplaire d'en-tête excel sheet"),
            _createElementVNode("div", {
              class: "alert alert-danger d-flex align-items-center",
              role: "alert"
            }, [
              _createElementVNode("i", { class: "feather icon-alert-triangle me-2" }),
              _createElementVNode("span", null, "Merci de respecter les noms des villes")
            ]),
            _createElementVNode("div", {
              class: "alert alert-danger d-flex align-items-center",
              role: "alert"
            }, [
              _createElementVNode("i", { class: "feather icon-alert-triangle me-2" }),
              _createElementVNode("span", null, [
                _createTextVNode(" La colonne "),
                _createElementVNode("strong", null, "\"ID\""),
                _createTextVNode(" est obligatoire et ne doit pas être dupliquée ")
              ])
            ]),
            _createElementVNode("div", { class: "table-responsive table-scroll-mobile" }, [
              _createElementVNode("table", { class: "table text-nowrap align-middle mb-0" }, [
                _createElementVNode("thead", { class: "table-light" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "ID"),
                    _createElementVNode("th", null, "CODE"),
                    _createElementVNode("th", null, "DESTINATAIRE"),
                    _createElementVNode("th", null, "TELEPHONE"),
                    _createElementVNode("th", null, "PRIX"),
                    _createElementVNode("th", null, "VILLE"),
                    _createElementVNode("th", null, "ADRESSE"),
                    _createElementVNode("th", null, "COMMENTAIRE"),
                    _createElementVNode("th", null, "PRODUIT")
                  ])
                ])
              ])
            ])
          ])
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-gray-100" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Clé "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (sheets.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sheets.value, (s) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: s.id
                    }, [
                      _createElementVNode("td", _hoisted_5, _toDisplayString(s.sheet_name), 1),
                      _createElementVNode("td", _hoisted_6, _toDisplayString(s.sheet_key), 1),
                      _createElementVNode("td", _hoisted_7, _toDisplayString(s.created_at), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-danger btn-sm",
                          onClick: ($event: any) => (removeSheet(s.id))
                        }, " 🗑 ", 8, _hoisted_8)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[2] || (_cache[2] = [
                    _createElementVNode("td", {
                      colspan: "4",
                      class: "text-center text-muted py-4"
                    }, [
                      _createElementVNode("span", null, "Aucune donnée disponible")
                    ], -1)
                  ])))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "addSheetyModal",
      tabindex: "-1",
      "aria-hidden": "true",
      ref_key: "addSheetyModal",
      ref: addSheetyModal
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "modal-title fs-5" }, "Nouveau Google Sheet", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: closeModal
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "alert alert-primary mb-3" }, [
              _createTextVNode(" La colonne "),
              _createElementVNode("b", null, "ID"),
              _createTextVNode(" est obligatoire et unique ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.sheet_name) = $event)),
              class: "form-control mb-3",
              placeholder: "Nom du sheet"
            }, null, 512), [
              [_vModelText, form.value.sheet_name]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sheet_key) = $event)),
              class: "form-control mb-3",
              placeholder: "Clé Google Sheet"
            }, null, 512), [
              [_vModelText, form.value.sheet_key]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: closeModal
            }, "Annuler"),
            _createElementVNode("button", {
              class: "btn btn-primary d-flex align-items-center",
              onClick: submit,
              disabled: loading.value
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(loading.value ? "Traitement..." : "Appliquer"), 1)
            ], 8, _hoisted_14)
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})